import axios from "axios";
import { SecureTokenManager } from "mdui/api/ApiCfg";
import { getField, encryptData, procModArgs, autoLoadTables, prepRefModArgs, convUploadform, prepareSearchData, prepareLoadDataParams } from "mdui/form/Util";
import { reloadCtrlCfg } from "./wuiUtils";

const exportViewPymntCsv = async ({ props, formData, config, ...data }) => {
    try {
            const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
            const token = SecureTokenManager.getAccessToken();
            let nFdata = formData || { table: {} };
            let uData = prepareSearchData(nFdata, config, props.field);
            let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
            // Make request with blob response type for file download
            const response = await axios.post(
                    `${BASE_URL}/get/exportViewPymtTrxn`,
                    { ...(param || {}), format: 'CSV' },                    {
                            responseType: 'blob',
                            headers: {
                                    Authorization: token ? `Bearer ${token}` : '',
                                    'Content-Type': 'application/json'
                            }
                    }
            );

            // Create blob from response
            const blob = new Blob([response.data], { type: 'text/csv' });

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from Content-Disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'export.csv';
            if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                            filename = filenameMatch[1].replace(/['"]/g, '');
                            // Handle UTF-8 encoded filenames
                            if (filename.startsWith('UTF-8\'\'')) {
                                    filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
                            }
                    }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
    } catch (error) {
            console.error('Error exporting CSV:', error);
            throw error;
    }
}

const exportViewPymntPdf = async ({ props, formData, config, ...data }) => {
    try {
        console.log("exportViewPymntPdf")
        const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
        const token = SecureTokenManager.getAccessToken();
        let nFdata = formData || { table: {} };
        let uData = prepareSearchData(nFdata, config, props.field);
        let param = prepareLoadDataParams(uData, props.field, config, 'search', false);

        // Backend streams the PDF directly in the response body
        const response = await axios.post(
            `${BASE_URL}/get/exportViewPymtTrxn`,
            { ...(param || {}), format: 'PDF' },            {
                responseType: 'blob', // required — treat response as binary data
                headers: {
                    Authorization: token ? `Bearer ${token}` : '',
                    'Content-Type': 'application/json'
                }
            }
        );

        // Create blob from response
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // Extract filename from Content-Disposition header
        console.log("response", response);
        const fileName = getFileNameFromResponse(response, 'export.pdf');
        console.log("filename", fileName);

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.remove();
        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.error('Error exporting PDF:', error);
        throw error;
    }
};

// Reused helper (same as CSV)
const getFileNameFromResponse = (response, fallbackName = 'download.pdf') => {
    const contentDisposition = response.headers['content-disposition'];
    let fileName = fallbackName;

    if (contentDisposition) {
        // RFC 5987 encoded form: filename*=UTF-8''encoded-name
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
        if (utf8Match && utf8Match[1]) {
            fileName = decodeURIComponent(utf8Match[1]);
        } else {
            // plain form: filename="name.ext" or filename=name.ext
            const plainMatch = contentDisposition.match(/filename\s*=\s*"?([^";\n]*)"?/i);
            if (plainMatch && plainMatch[1]) {
                fileName = plainMatch[1].trim();
            }
        }
    }

    return fileName;
};

const exportPymntTrxnCsv = async ({ props, formData, config, ...data }) => {
    try {
            const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
            const token = SecureTokenManager.getAccessToken();
            let nFdata = formData || { table: {} };
            let uData = prepareSearchData(nFdata, config, props.field);
            let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
            // Make request with blob response type for file download
            const response = await axios.post(
                    `${BASE_URL}/get/exportCsv`,
                    param || {},
                    {
                            responseType: 'blob',
                            headers: {
                                    Authorization: token ? `Bearer ${token}` : '',
                                    'Content-Type': 'application/json'
                            }
                    }
            );

            // Create blob from response
            const blob = new Blob([response.data], { type: 'text/csv' });

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from Content-Disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'export.csv';
            if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                            filename = filenameMatch[1].replace(/['"]/g, '');
                            // Handle UTF-8 encoded filenames
                            if (filename.startsWith('UTF-8\'\'')) {
                                    filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
                            }
                    }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
    } catch (error) {
            console.error('Error exporting CSV:', error);
            throw error;
    }
}

const exportViewTrxnLogCsv = async ({ props, formData, config, handleApiError, ...data }) => {
        try {
                const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
                const token = SecureTokenManager.getAccessToken();
                let nFdata = formData || { table: {} };
                let uData = prepareSearchData(nFdata, config, props.field);
                let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
                // Make request with blob response type for file download
                const response = await axios.post(
                        `${BASE_URL}/get/exportViewTrxnLog`,
                        { ...(param || {}), format: 'CSV' },                    {
                                responseType: 'blob',
                                headers: {
                                        Authorization: token ? `Bearer ${token}` : '',
                                        'Content-Type': 'application/json'
                                }
                        }
                );
                let fileData = response.data;
                // responseType is 'blob', so a JSON error/warning payload from the backend
                // arrives as a Blob too, not a plain object - fileData.warnings would never
                // be set. Detect it via content-type and parse it out before treating the
                // response as CSV data.
                const contentType = response.headers['content-type'] || '';
                if (contentType.includes('application/json')) {
                    const json = JSON.parse(await fileData.text());
                    if (json.warnings !== undefined) {
                        handleApiError({RESP_CD: '9999', warnings: json.warnings}, {module: props.module, ...data});
                        return;
                    }
                }
                // Create blob from response
                const blob = new Blob([fileData], { type: 'text/csv' });
    
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
    
                // Get filename from Content-Disposition header or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'export.csv';
                if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                                filename = filenameMatch[1].replace(/['"]/g, '');
                                // Handle UTF-8 encoded filenames
                                if (filename.startsWith('UTF-8\'\'')) {
                                        filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
                                }
                        }
                }
    
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
    
                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
        } catch (error) {
                console.error('Error exporting CSV:', error);
                throw error;
        }
    }
    
    const exportTrxnLogPdf = async ({ props, handleApiError, formData, config, ...data }) => {
        try {
            console.log("exportViewPymntPdf")
            const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
            const token = SecureTokenManager.getAccessToken();
            let nFdata = formData || { table: {} };
            let uData = prepareSearchData(nFdata, config, props.field);
            let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
    
            // Backend streams the PDF directly in the response body
            const response = await axios.post(
                `${BASE_URL}/get/exportViewTrxnLog`,
                { ...(param || {}), format: 'PDF' },            {
                    responseType: 'blob', // required — treat response as binary data
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            let fileData = response.data;
                // responseType is 'blob', so a JSON error/warning payload from the backend
                // arrives as a Blob too, not a plain object - fileData.warnings would never
                // be set. Detect it via content-type and parse it out before treating the
                // response as CSV data.
                const contentType = response.headers['content-type'] || '';
                if (contentType.includes('application/json')) {
                    const json = JSON.parse(await fileData.text());
                    if (json.warnings !== undefined) {
                        handleApiError({RESP_CD: '9999', warnings: json.warnings}, {module: props.module, ...data});
                        return;
                    }
                }

            // Create blob from response
            const blob = new Blob([fileData], { type: 'application/pdf' });
    
            // Extract filename from Content-Disposition header
            console.log("response", response);
            const fileName = getFileNameFromResponse(response, 'export.pdf');
            console.log("filename", fileName);
    
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
    
        } catch (error) {
            console.error('Error exporting PDF:', error);
            throw error;
        }
    };

    const exportCsv = async ({ props, formData, config, ...data }) => {
        try {
                const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
                const token = SecureTokenManager.getAccessToken();
                let nFdata = formData || { table: {} };
                let uData = prepareSearchData(nFdata, config, props.field);
                let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
                // Make request with blob response type for file download
                const response = await axios.post(
                        `${BASE_URL}/get/exportCsv`,
                        { ...(param || {}), format: 'CSV' },                    {
                                responseType: 'blob',
                                headers: {
                                        Authorization: token ? `Bearer ${token}` : '',
                                        'Content-Type': 'application/json'
                                }
                        }
                );
    
                // Create blob from response
                const blob = new Blob([response.data], { type: 'text/csv' });
    
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
    
                // Get filename from Content-Disposition header or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'export.csv';
                if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                                filename = filenameMatch[1].replace(/['"]/g, '');
                                // Handle UTF-8 encoded filenames
                                if (filename.startsWith('UTF-8\'\'')) {
                                        filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
                                }
                        }
                }
    
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
    
                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
        } catch (error) {
                console.error('Error exporting CSV:', error);
                throw error;
        }
    }
    
    const exportPdf = async ({ props, formData, config, ...data }) => {
        try {
            console.log("exportViewPymntPdf")
            const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
            const token = SecureTokenManager.getAccessToken();
            let nFdata = formData || { table: {} };
            let uData = prepareSearchData(nFdata, config, props.field);
            let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
    
            // Backend streams the PDF directly in the response body
            const response = await axios.post(
                `${BASE_URL}/get/exportCsv`,
                { ...(param || {}), format: 'PDF' },            {
                    responseType: 'blob', // required — treat response as binary data
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            // Create blob from response
            const blob = new Blob([response.data], { type: 'application/pdf' });
    
            // Extract filename from Content-Disposition header
            console.log("response", response);
            const fileName = getFileNameFromResponse(response, 'export.pdf');
            console.log("filename", fileName);
    
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
    
        } catch (error) {
            console.error('Error exporting PDF:', error);
            throw error;
        }
    };

    const exportAdvicePdf = async ({ props, formData, config, row,...data }) => {
        try {
            console.log("exportAdvicePdf")
            const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
            const token = SecureTokenManager.getAccessToken();
            let nFdata = props?.row || { table: {} };
            console.log("nFdata", nFdata);
            console.log("row", props.row);
            let uData = prepareSearchData(nFdata, config, props.field);
            let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
    
            // Backend streams the PDF directly in the response body
            const response = await axios.post(
                `${BASE_URL}/get/exportAdvice`,
                { ...(param || {}), format: 'PDF' },            {
                    responseType: 'blob', // required — treat response as binary data
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            // Create blob from response
            const blob = new Blob([response.data], { type: 'application/pdf' });
    
            // Extract filename from Content-Disposition header
            console.log("response", response);
            const fileName = getFileNameFromResponse(response, 'export.pdf');
            console.log("filename", fileName);
    
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
    
        } catch (error) {
            console.error('Error exporting PDF:', error);
            throw error;
        }
    };

/**
 * Sanction screening receipt PDF download.
 * Mirrors exportViewPymntPdf; posts to exportSancScrPdf (legacy download.page).
 */
const exportSancScrPdf = async ({ props, formData, config, ...data }) => {
    try {
        console.log("exportSancScrPdf");
        console.log("props", props);
        console.log("formData", formData);
        console.log("config", config);
        console.log("data", data);
        const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
        const token = SecureTokenManager.getAccessToken();
        let nFdata = formData || props?.row || { table: {} };
        console.log("nFdata", nFdata);
        let uData = prepareSearchData(nFdata, config, props.field);
        console.log("uData", uData);
        uData = {...uData, ...nFdata }
        let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
        console.log("param", param);
        // Backend streams the screening receipt PDF directly in the response body
        const response = await axios.post(
            `${BASE_URL}/get/exportSancScrPdf`,
            { ...(param || {}), format: 'PDF' },
            {
                responseType: 'blob',
                headers: {
                    Authorization: token ? `Bearer ${token}` : '',
                    'Content-Type': 'application/json'
                }
            }
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const fileName = getFileNameFromResponse(response, 'screening_result.pdf');

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error exporting sanction screening PDF:', error);
        throw error;
    }
};

const reloadTxType = async ({ props, updateState, formData, ctrlCfg, config, ...data }) => {
    let selectData = []
    let mode = formData?.processMode;
    if (mode !== '') {
        selectData = mode === 'Realtime' ? ctrlCfg.viewPymtTrxn_txCd_RT : ctrlCfg.viewPymtTrxn_txCd_BP
    }
    let key = 'viewPymtTrxn_txCd';
    const newCtrlCfg = { ...ctrlCfg, [key]: selectData };
    const newFormData = { ...formData, 'txCd': '' };

    // Build new attr object following the same pattern as cbftChrgBrFeeCal
    let nattr = { ...data.attr };
    let mainTbl = { ...(nattr['mainTbl'] || {}) };

    if (mode === 'Realtime') {
        nattr['fileNm'] = { ...(nattr['fileNm'] || {}), hide: true };
        nattr['chnlfeTxId'] = { ...(nattr['chnlfeTxId'] || {}), hide: false };
        mainTbl['fileNm'] = { ...(mainTbl['fileNm'] || {}), hide: true };
        mainTbl['chnlfeTxId'] = { ...(mainTbl['chnlfeTxId'] || {}), hide: false };
        delete newFormData['fileNm'];
    } else if (mode === 'Bulk') {
        nattr['chnlfeTxId'] = { ...(nattr['chnlfeTxId'] || {}), hide: true };
        nattr['fileNm'] = { ...(nattr['fileNm'] || {}), hide: false };
        mainTbl['chnlfeTxId'] = { ...(mainTbl['chnlfeTxId'] || {}), hide: true };
        mainTbl['fileNm'] = { ...(mainTbl['fileNm'] || {}), hide: false };
        delete newFormData['chnlfeTxId'];
    }

    nattr['mainTbl'] = mainTbl;

    updateState({ newFormData, newCtrlCfg, newAttr: nattr });
}
const reloadCtrlType = async ({ props, updateState, formData, ctrlCfg, config, ...data }) => {
    let selectData = []
    let chnlSelectData = []
    let mode = formData?.processMode;
    if (mode !== '') {
        selectData = mode === 'Realtime' ? ctrlCfg.viewPymtTrxn_txCd_RT : ctrlCfg.viewPymtTrxn_txCd_BP
        chnlSelectData = mode === 'Realtime' ? ctrlCfg.viewPymtTrxn_rqstChnl_RT : ctrlCfg.viewPymtTrxn_rqstChnl_BP
    }
    console.log('mode:', mode, 'chnlRT:', ctrlCfg.viewPymtTrxn_rqstChnl_RT, 'chnlBP:', ctrlCfg.viewPymtTrxn_rqstChnl_BP);
    let key = 'viewPymtTrxn_txCd';
    let chnlKey = 'viewPymtTrxn_rqstChnl';
    let loadRqstChnl = mode === 'Realtime' ? 'VIEW_RQST_CHNL_RT' : 'VIEW_RQST_CHNL_BT';
    const newCtrlCfg = {
        ...ctrlCfg,
        [key]: selectData,
        [chnlKey]: chnlSelectData,
        loadRqstChnl
    };
    console.log('newCtrlCfg', newCtrlCfg);
    const newFormData = { ...formData, 'txCd': '', 'rqstChnl': '' };

    // Build new attr object following the same pattern as cbftChrgBrFeeCal
    let nattr = { ...data.attr };
    let mainTbl = { ...(nattr['mainTbl'] || {}) };

    if (mode === 'Realtime') {
        nattr['fileNm'] = { ...(nattr['fileNm'] || {}), hide: true };
        nattr['chnlfeTxId'] = { ...(nattr['chnlfeTxId'] || {}), hide: false };
        mainTbl['fileNm'] = { ...(mainTbl['fileNm'] || {}), hide: true };
        mainTbl['chnlfeTxId'] = { ...(mainTbl['chnlfeTxId'] || {}), hide: false };
        delete newFormData['fileNm'];
    } else if (mode === 'Bulk') {
        nattr['chnlfeTxId'] = { ...(nattr['chnlfeTxId'] || {}), hide: true };
        nattr['fileNm'] = { ...(nattr['fileNm'] || {}), hide: false };
        mainTbl['chnlfeTxId'] = { ...(mainTbl['chnlfeTxId'] || {}), hide: true };
        mainTbl['fileNm'] = { ...(mainTbl['fileNm'] || {}), hide: false };
        delete newFormData['chnlfeTxId'];
    }

    nattr['mainTbl'] = mainTbl;

 //   await reloadCtrlCfg({ props, formData: newFormData, newCtrlCfg, config, updateState, ...data, newAttr: nattr });

 updateState({ newFormData, newCtrlCfg, newAttr: nattr });
}

const reloadTxCd = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    const{txCd='', ...restData} = { ...formData }
    if (formData.rqstChnl && formData.rqstChnl != '') {
        let loadTxCd = formData.rqstChnl === 'BPRTBFST' ? 'RTBFST_TXN' : 'G3_TXN';
        let newFormData = { ...restData, loadTxCd, txCd:'' }
        console.log("print newFormData", newFormData);
        await reloadCtrlCfg({ props, formData: newFormData, ctrlCfg, config, updateState, ...args });
        return;
    }
    await reloadCtrlCfg({ props, restData, ctrlCfg, config, updateState, ...args });
}

export { reloadTxType, reloadCtrlType,exportViewPymntCsv, exportViewPymntPdf, exportPymntTrxnCsv, exportViewTrxnLogCsv, exportTrxnLogPdf, exportCsv, exportPdf, exportAdvicePdf, exportSancScrPdf, reloadTxCd }